export const comments_4322236 = {"data":{"data":[],"links":{}}}